<template>
  <div class="page-not-found">
    <h1>404</h1>
    <h2>{{ $t('errors.page_not_found.title') }}</h2>
    <p>{{ $t('errors.page_not_found.message') }}</p>
    <el-button type="secondary" @click="$router.push({ name: 'HomePage' })">
      {{ $t('errors.page_not_found.back_home') }}
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
};
</script>

<style scoped>
.page-not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
  padding: 20px;
}

h1 {
  font-size: 8rem;
  margin-bottom: 1rem;
  color: darkgrey;
}

h2 {
  font-size: 2rem;
  margin-bottom: 1rem;
}

p {
  margin-bottom: 2rem;
  color: #666;
}
</style> 